<template>
  <b-container>
    <div class="row d-flex align-items-center justify-content-center vertical">
      <div
        class="col-xl-6"
        v-if="meeting && meeting.inviter.uuid === $auth.user().uuid"
      >
        <h1>Scheduled Meeting</h1>

        <div class="box">
          <h2>
            Your meeting has been
            <span v-if="meeting.status === 'pending'">submitted.</span>
            <span v-if="meeting.status === 'approved'">approved.</span>
            <span v-if="meeting.status === 'declined'">declined.</span>
          </h2>

          <p v-if="meeting.status === 'pending'">
            Once your advisor approves your meeting we will send you contact
            information to finalize the meeting details.
          </p>

          <div
            v-if="
              meeting.educational_item &&
                $auth.user().user_type === 'entrepreneur' &&
                meeting.status === 'approved'
            "
          >
            <hr style="margin-bottom: 2rem;" />
            <b-row>
              <b-col cols="12" class="mb-2">
                Your advisor has attached the following Educational Resource to
                this meeting.
              </b-col>
              <b-col cols="12">
                <educational-item-summary
                  :resource="meeting.educational_item"
                  actionTitle="View"
                  v-on:action-button-tapped="viewResource()"
                ></educational-item-summary>
              </b-col>
            </b-row>
          </div>

          <p v-if="meeting.status === 'approved'">
            Please reach out to
            <a :mailto="meeting.invitee.email">
              {{ meeting.invitee.first_name }} {{ meeting.invitee.last_name }}
            </a>
            to finalize any details.
          </p>

          <p v-if="meeting.status === 'declined'">
            Your advisor has declined your meeting.
          </p>

          <router-link to="/dashboard" class="btn btn-sm btn-secondary"
            >Go to Dashboard</router-link
          >
        </div>
      </div>

      <div
        class="col-xl-6"
        v-if="meeting && meeting.invitee.uuid === $auth.user().uuid"
      >
        <h1>Scheduled Meeting</h1>

        <div class="box">
          <p v-if="meeting.status === 'pending'">
            <router-link :to="'/user/' + meeting.inviter.uuid">
              {{ meeting.invitee.first_name }} {{ meeting.invitee.last_name }}
            </router-link>
            has requested a meeting with you:
          </p>

          <p v-if="meeting.status !== 'pending'">
            You have {{ meeting.status }} this meeting.
          </p>

          <hr style="margin-top: 1.5rem;" />

          <div class="d-flex justify-content-around my-3">
            <div>
              <strong>Date</strong><br />
              {{ meeting.date }}
            </div>

            <div>
              <strong>Time</strong><br />
              {{ meeting.start_time }}
            </div>

            <div>
              <strong>Location</strong><br />
              <span v-if="meeting.meeting_type === 'in-person'">
                In-Person
              </span>

              <span v-if="meeting.meeting_type === 'remote'">
                Remote
              </span>
            </div>
          </div>

          <div
            v-if="
              meeting.educational_item &&
                $auth.user().user_type === 'entrepreneur'
            "
          >
            <hr style="margin-bottom: 2rem;" />
            <b-row>
              <b-col cols="12" class="mb-2">
                Your advisor has attached the following Educational Resource to
                this meeting.
              </b-col>
              <b-col cols="12">
                <educational-item-summary
                  :resource="meeting.educational_item"
                  actionTitle="View"
                  v-on:action-button-tapped="
                    viewResource(meeting.educational_item)
                  "
                ></educational-item-summary>
              </b-col>
            </b-row>
          </div>

          <b-row v-if="meeting.status === 'pending'">
            <b-col cols="12">
              <b-btn
                class="mb-3"
                variant="secondary"
                v-if="
                  $auth.user().user_type === 'advisor' &&
                    meeting.inviter.user_type === 'entrepreneur' &&
                    selectedResource == null
                "
                @click="showResources = true"
              >
                Attach Resource
              </b-btn>
              <educational-item-summary
                v-if="selectedResource != null"
                :resource="selectedResource"
                actionTitle="Remove"
                v-on:action-button-tapped="removeResource()"
              ></educational-item-summary>
            </b-col>
            <b-col>
              <b-btn variant="secondary" block @click="accept(meeting.uuid)">
                Approve
              </b-btn>
            </b-col>

            <b-col>
              <b-btn variant="danger" block @click="decline(meeting.uuid)">
                Decline
              </b-btn>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
    <educational-item-selection-modal
      v-on:resource-selected="resourceSelected($event)"
      :show="showResources"
      @dismiss="showResources = false"
    ></educational-item-selection-modal>
  </b-container>
</template>

<script>
import EducationalItemSummary from '@/components/educational_resources/EducationalItemSummary'
import EducationalItemSelectionModal from '@/components/educational_resources/EducationalItemSelectionModal'
export default {
  name: 'MeetingsConfirmation',
  components: {
    EducationalItemSummary,
    EducationalItemSelectionModal,
  },
  data() {
    return {
      uuid: null,
      meeting: null,
      loading: false,
      showResources: false,
      selectedResource: null,
    }
  },
  mounted() {
    this.uuid = this.$route.params.uuid
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      this.$http
        .get(`/meetings/${this.uuid}`)
        .then(
          (res) => {
            this.meeting = res.data.data
          },
          () => {}
        )
        .finally(() => {
          this.loading = false
        })
    },
    accept() {
      // Need to add in the educational_item_id if one is selected by the admin
      let resourceId = null
      if (this.selectedResource) {
        resourceId = this.selectedResource.id.toString()
      }
      this.$http
        .post(`meetings/accept`, {
          meeting_uuid: this.uuid,
          item_id: resourceId,
        })
        .finally(() => {
          window.location.reload()
        })
    },
    decline() {
      this.$bvModal
        .msgBoxConfirm('Are your sure you want to decline this invitation?', {
          centered: true,
          title: 'Decline Invitation',
        })
        .then((value) => {
          if (!value) {
            return
          }

          this.$http.post(`meetings/decline/${this.uuid}`).finally(() => {
            window.location.reload()
          })
        })
    },
    resourceSelected(resource) {
      this.selectedResource = resource
      this.showResources = false
    },
    removeResource() {
      this.selectedResource = null
    },
    viewResource(resource) {
      let routeData = this.$router.resolve({
        path: `/resources/${resource.uuid}`,
      })
      window.open(routeData.href, '_blank')
    },
  },
}
</script>
